// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 63 ? "ImportFuncDemo" : chunkId) + "." + {"63":"7b5e7ec5","468":"7e5e971a"}[chunkId] + ".css";
};